/** Skill 平台「仅引流」态：不写入 UC session，与 user.ts 的 SESSION/UIN 分离 */
export const SKILLHUB_LEAD_FLAG = 'skillhubLeadOnly'
export const SKILLHUB_LEAD_VALUE = 'skillhubLeadValue'
